import styled from 'styled-components';

export const AlertsContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.offWhite};
  border-radius: ${({ theme }) => theme.borderRadius};
  overflow-y: scroll;
  margin-top: ${({ theme }) => theme.spacing.xs};
  height: 30%;
  max-height: 30%;
`;
export const EachAlert = styled.div`
  /* border: 1px solid grey; */
  box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.1);
  margin: ${({ theme }) => theme.spacing.m};
  padding: ${({ theme }) => theme.spacing.m};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs};
  border-radius: ${({ theme }) => theme.borderRadius};
  p {
    color: ${({ theme }) => theme.colors.grey7};
    font-weight: bold;
    padding-bottom: ${({ theme }) => theme.spacing.xxxs};
    /* border: 1px solid purple; */
  }
  span {
    color: ${({ theme }) => theme.colors.grey5};
    font-style: italic;
    font-weight: light;
  }
`;
export const AlertDetails = styled.div`
  div {
    display: flex;
    gap: ${({ theme }) => theme.spacing.xxxs};
    flex-wrap: wrap;
  }
`;
